import { useEffect } from "react";
import { useAuthStore } from "../contexts/AuthContext";
import { useCubeDataDispatch } from "../contexts/CubeDataContext";

export default function useGetAccountCustomJoins() {
  const { selectedAccount, user } = useAuthStore();
  const cubeDataDispatch = useCubeDataDispatch();

  useEffect(() => {
    const fetchCustomJoins = async () => {
      try {
        const response = await fetch(
          `/api/accounts/${user.isSuperAdmin && !selectedAccount?.id ? 0 : selectedAccount?.id}/custom-joins`
        );

        if (!response.ok) {
          const text = await response.text();
          console.error("Server response:", text);
          throw new Error(text);
        }

        const data = await response.json();
        cubeDataDispatch({
          type: "setAccountCustomJoins",
          payload: data?.AccountCustomJoins,
        });
      } catch (error) {
        console.error("Fetch error with Account Custom Joins:", error);
      }
    };

    fetchCustomJoins();
  }, [selectedAccount?.id, cubeDataDispatch, user?.isSuperAdmin]);
}
